import { AsyncValidator, FormControl, FormGroup, ValidationErrors } from "@angular/forms";
import { Observable, catchError, map, of, switchMap, timer } from "rxjs";
import { SharedApiService } from "../services/shared-api.service";
import { BankAccountStatus, BankAccountType } from "common";
import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class BankDetailsValidator implements AsyncValidator {
    constructor(private apiService: SharedApiService) { }

    public validate(form: FormGroup<{
        bankId: FormControl<number | null>;
        branchCode: FormControl<string | null>;
        bankAccountType: FormControl<BankAccountType | null>;
        bankAccountNumber: FormControl<string | null>;
    }>): Observable<ValidationErrors | null> {
        // Values are guaranteed to be present because the form is valid (async validators are only called after sync validators pass).
        const fValue = form.getRawValue() as { bankId: number, branchCode: string, bankAccountType: BankAccountType, bankAccountNumber: string };

        return timer(500).pipe(
            switchMap(() => {
                return this.apiService.validateBankDetails(fValue.bankId, fValue.bankAccountType, fValue.bankAccountNumber)
                    .pipe(
                        map((response) => {
                            const controls = [form.controls.bankId, form.controls.branchCode, form.controls.bankAccountType, form.controls.bankAccountNumber];
                            const isValid = response !== undefined && response !== null && response === BankAccountStatus.Validated;

                            // If the bank details are invalid, mark each control as invalid.
                            if (!isValid) {
                                controls.forEach(control => {
                                    // Set the error on the control.
                                    control.setErrors({ pleaseCheck: true });

                                    // Mark as dirty to show the error message immediately.
                                    control.markAsDirty();
                                });

                                // Mark the form fields as each touched, this helps to indicate that something has happened to the form.
                                form.markAllAsTouched();

                            } else {
                                // Clear any existing errors.
                                controls.forEach(control => control.setErrors(null));
                                // Mark only the form as touched, this prevents green borders around the inputs while showing the check above the inputs.
                                form.markAsTouched();
                            }


                            return isValid ? null : { invalidBankDetails: true };
                        }),
                        catchError(() => of(null)), // TODO: Handle api errors?
                    );
            })
        );

    }
}